"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DirectReach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    number: "01",
    label: "RESIDENTIAL MOWING",
    description: "Precision cutting schedules for estate lawns and residential properties.",
    email: "acostalawncare@gmail.com",
    phone: "6823205738",
    contactName: "Acosta",
    contactRole: "Lead Operator"
  }, {
    number: "02",
    label: "EDGING & TRIMMING",
    description: "Architectural boundary definition and detailed perimeter maintenance.",
    email: "acostalawncare@gmail.com",
    phone: "6823205738",
    contactName: "Acosta",
    contactRole: "Precision Specialist"
  }, {
    number: "03",
    label: "COMMERCIAL CONTRACTS",
    description: "Scalable maintenance solutions for corporate campuses and retail spaces.",
    email: "acostalawncare@gmail.com",
    phone: "6823205738",
    contactName: "Acosta",
    contactRole: "Project Manager"
  }, {
    number: "04",
    label: "ESTIMATE REQUESTS",
    description: "On-site evaluations and technical specifications for your turf management.",
    email: "acostalawncare@gmail.com",
    phone: "6823205738",
    contactName: "Acosta",
    contactRole: "Chief Estimator"
  }];
  return <section data-section-id="4795" id="direct-reach" className="dark bg-background text-foreground py-24 md:py-32 lg:py-44 px-6 md:px-10 lg:px-16">
      <div ref={ref} className={`max-w-[1400px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-20 md:mb-28 lg:mb-32">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs tracking-[0.2em] text-primary mb-8 md:mb-10" style={{
            fontFamily: "var(--font-mono)"
          }}>
              — [CONTACT.01] DIRECT REACH
            </div>
            <h2 className="font-default font-extrabold text-5xl md:text-7xl lg:text-[88px] leading-[0.9] tracking-tighter text-foreground">
              The Precision{" "}
              <span className="italic font-normal" style={{
              fontFamily: "var(--font-serif)"
            }}>
                Line.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex lg:items-end">
            <p className="text-lg md:text-xl leading-relaxed text-muted-foreground" style={{
            fontFamily: "var(--font-sans)"
          }}>
              Direct access to our specialized maintenance divisions. Every blade of grass is managed by a dedicated technician.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-border">
          {departments.map((dept, i) => <div data-index={i} key={dept.number} className={`group relative flex flex-col px-0 md:px-8 lg:px-10 py-12 md:py-14 transition-colors duration-500 hover:bg-moss-shadow ${i < departments.length - 1 ? "border-b border-border md:border-b lg:border-b-0" : ""} ${i % 2 === 0 ? "md:border-r md:border-border" : ""} ${i < 2 ? "md:border-b md:border-border lg:border-b-0" : ""} lg:border-r lg:border-border lg:last:border-r-0`}>
              {}
              <div className="font-mono text-[11px] tracking-[0.2em] text-primary mb-10 md:mb-14" style={{
            fontFamily: "var(--font-mono)"
          }}>
                {dept.number} // {dept.label}
              </div>

              {}
              <p className="text-2xl leading-[1.3] text-foreground mb-14 md:mb-20 flex-1 font-default font-semibold" style={{
            fontFamily: "var(--font-sans)"
          }}>
                {dept.description}
              </p>

              {}
              <div className="space-y-6">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    EMAIL_SPEC
                  </div>
                  <Link to={`mailto:${dept.email}`} className="text-base text-foreground hover:text-primary hover:underline decoration-primary underline-offset-4 transition-colors duration-300 break-all font-default">
                    {dept.email}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    VOICE_LINE
                  </div>
                  <Link to={`tel:${dept.phone.replace(/[^\d+]/g, "")}`} className="text-base text-foreground hover:text-primary transition-colors duration-300 font-default">
                    {dept.phone}
                  </Link>
                </div>

                <div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-muted-foreground mb-2" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    OPERATOR
                  </div>
                  <div className="text-base text-foreground font-default">
                    <span className="font-semibold">{dept.contactName}</span>
                    <span className="text-steel-edger"> / </span>
                    <span className="text-muted-foreground">{dept.contactRole}</span>
                  </div>
                </div>

                {}
                <div className="pt-8">
                  <Link to="/GetQuotePage" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.2em] text-primary hover:gap-4 transition-all duration-300" style={{
                fontFamily: "var(--font-mono)"
              }}>
                    <ArrowRight className="size-3" />
                    INITIATE CONTACT
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}